import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LangSwitcher } from '../LangSwitcher/LangSwitcher';
import marginLogo from '../../assets/vectorlogo.png';
import './TopNav.css';

interface TopNavProps {
  onLogout: () => void;
  /** if set, renders a "back" link in the breadcrumb */
  back?: () => void;
  /** override the back-link label (default: t('back') from common ns) */
  backLabel?: string;
  /** breadcrumb title shown after the logo / back link */
  title?: React.ReactNode;
  /** extra page-specific buttons rendered before the lang switcher */
  actions?: React.ReactNode;
}

export const TopNav: React.FC<TopNavProps> = ({
  onLogout,
  back,
  backLabel,
  title,
  actions,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  const hasCrumb = !!(back || title);

  return (
    <header className="mg-topnav">
      <div className="mg-topnav__left">
        <button
          className="mg-topnav__brand"
          onClick={() => navigate('/forms')}
          type="button"
          aria-label="lovestoria"
        >
          <img src={marginLogo} alt="lovestoria" className="mg-topnav__brand-img" />
        </button>
        {hasCrumb && <span className="mg-topnav__sep">/</span>}
        {back && (
          <button
            className="mg-topnav__back"
            onClick={back}
            type="button"
          >
            {backLabel ?? (t('back') as string)}
          </button>
        )}
        {back && title && <span className="mg-topnav__sep">/</span>}
        {title && <span className="mg-topnav__title">{title}</span>}
      </div>
      <div className="mg-topnav__right">
        {actions && <div className="mg-topnav__actions">{actions}</div>}
        <LangSwitcher />
        <button className="mg-topnav__logout" onClick={onLogout} type="button">
          {t('logout')}
        </button>
      </div>
    </header>
  );
};
